import { render, staticRenderFns } from "./showRestrictions.vue?vue&type=template&id=04f808fe&scoped=true&"
import script from "./showRestrictions.vue?vue&type=script&lang=js&"
export * from "./showRestrictions.vue?vue&type=script&lang=js&"
import style0 from "./showRestrictions.vue?vue&type=style&index=0&id=04f808fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f808fe",
  null
  
)

export default component.exports